import React, { useState } from "react";
import SizeItem from "../SizeItem";
import { ASSETS } from "../../../../utils/config.js";
import * as Styled from "./styles.js";

function SizeBox({
  fullWidth,
  handleWidthChange,
  title = "Content Width",
  secondTitle = "Full Width",
}) {
  return (
    <Styled.Container>
      <Styled.SizeHeading>Size</Styled.SizeHeading>
      <Styled.RowDiv>
        <SizeItem
          title={title}
          isSelected={!fullWidth}
          image={ASSETS.segmentEditor.ContentWidth}
          onClick={() => handleWidthChange("content")}
        />
        <SizeItem
          title={secondTitle}
          isSelected={fullWidth}
          image={ASSETS.segmentEditor.FullWidth}
          onClick={() => handleWidthChange("full")}
        />
      </Styled.RowDiv>
    </Styled.Container>
  );
}

export default SizeBox;
